import httpclient from './httpclient'

export default {
    install: (Vue) => {
        Vue['hc'] = httpclient;
        Vue.prototype.$hc = httpclient;
    }
}